module.exports = __webpack_public_path__ + "img/qrcode.0c418978.png";